import { render, staticRenderFns } from "./demandContent.vue?vue&type=template&id=6f0af70a&scoped=true"
import script from "./demandContent.vue?vue&type=script&lang=js"
export * from "./demandContent.vue?vue&type=script&lang=js"
import style0 from "./demandContent.vue?vue&type=style&index=0&id=6f0af70a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0af70a",
  null
  
)

export default component.exports